import { TeoCore } from '@/teoCore/TeoCore';
import type { TeoNotificationParams } from '@/teoCore/TeoNotifications';
import { useAtomValue } from '@/utils/jotai-svelte';
import { onMountWithCore, teoCoreAtom } from '@/utils/teo-context';

export function useNotificationActions() {
  return {
    addNotification: (params: TeoNotificationParams) => TeoCore.instance.notifications.add(params),
    closeNotification: (id: number) => TeoCore.instance.notifications.close(id),
    closeAll: () => TeoCore.instance.notifications.closeAll(),
  };
}

const NotificationAtom$ = teoCoreAtom((core) => core.notifications.currentNotification);
NotificationAtom$.onMount = onMountWithCore(({ refresh }, core) =>
  core.notifications.addEventListener('notificationsChanged', refresh),
);
export const useNotificationState = () => useAtomValue(NotificationAtom$);

export function useNotification() {
  return [useNotificationState(), useNotificationActions()] as const;
}
